import $ = require("jquery");
import Backbone = require("backbone");
import Utils = require("../utils");
import Services = require("arcgis/services");
import FeatureServer = require("arcgis/services/featureserver");
import MapServer = require("arcgis/services/mapserver");
import ImageServer = require("arcgis/services/imageserver");
import _ = require("underscore");

var jsonFormat = "?f=json";

function removeQuery(value) {
    return Utils.leftOf(value, "?");
}

export class ServiceModel extends Backbone.Model {
    static about = `
Internal.  Model containing service information.
    `;
}

export class ServiceDirectoryModel extends Backbone.Model implements Services.Directory {

    static about = `
ArcGIS Server Discovery services.
    `;

    attributes: {
        currentVersion: number;
        isFolder: boolean;
        folders: Array<string>;
        /// etc.
    }

    // attributes shortcut
    get data() {
        return this.attributes;
    }

    get currentVersion(): number {
        return this.get("currentVersion");
    }

    get folders(): Array<string> {
        return this.get("folders");
    }

    get services(): Array<{ name: string; type: string; }> {
        return this.get("services");
    }

    exploreService(service: {
        url?: string;
        name?: string;
        type?: string;
    }) {
        var model = new ServiceModel();
        let serviceName = service.name;

        if (this.data.isFolder) {
            // the folder name is (always?) part of the service name so remove it
            serviceName = service.name.split("/").pop();
        }
        model.url = (service.url ? service.url : removeQuery(this.url) + "/" + serviceName + "/" + service.type) + jsonFormat;
        model["service"] = service; // hack, don't use a model use xdr
        return model;
    }

    exploreFolder(name: string) {
        var model = new ServiceDirectoryModel({
            isFolder: true
        });
        var urlRoot = removeQuery(this.url);
        model.url = urlRoot + "/" + name + jsonFormat;
        return model;
    }

    fetchFeatureServices(s: ServiceDirectoryModel) {
        var services = <Array<Rhythm.GIS.ServiceEndpoint<FeatureServer.FeatureServer>>>[];
        return this.fetchServices(s, services, "FeatureServer");
    }

    fetchMapServices(s: ServiceDirectoryModel) {
        var services = <Array<Rhythm.GIS.ServiceEndpoint<MapServer.MapServer>>>[];
        return this.fetchServices(s, services, "MapServer");
    }

    fetchImageServices(s: ServiceDirectoryModel) {
        var services = <Array<Rhythm.GIS.ServiceEndpoint<ImageServer.ImageServer>>>[];
        return this.fetchServices(s, services, "ImageServer");
    }

    fetchService<T>(childService: ServiceModel) {
        var d = $.Deferred<Rhythm.GIS.ServiceEndpoint<T>>();
        childService.fetch({
            success: () => {
                var serviceEndpoint = {
                    name: childService["service"].name,
                    type: childService["service"].type,
                    url: removeQuery(childService.url),
                    info: <T>childService.attributes
                };
                d.resolve(serviceEndpoint);
            },
            error: () => {
                var serviceEndpoint = {
                    name: childService["service"].name,
                    type: childService["service"].type,
                    url: removeQuery(childService.url),
                    info: null
                };
                d.resolve(serviceEndpoint);
            },
            proxy: true
        });
        return d;
    }

    private fetchServices<T>(s: ServiceDirectoryModel, services: Array<Rhythm.GIS.ServiceEndpoint<T>>, serviceType: string) {
        var d = $.Deferred<Array<Rhythm.GIS.ServiceEndpoint<T>>>();
        if (!s.services || !s.services.length) {
            d.resolve(services);
            return d;
        }

        var serviceList = s.services;
        if (serviceType) {
            serviceList = serviceList.filter(s=> s.type === serviceType);
        }
        var childServices = serviceList.map(f => s.exploreService(f));

        Utils.when(childServices.map(childService => this.fetchService<T>(childService))).done(services => {
            d.resolve(services);
        });

        return d;

    }

    fetchFolders(s: ServiceDirectoryModel) {

        let d = $.Deferred<Array<ServiceDirectoryModel>>();
        if (!s.folders || !s.folders.length) {
            d.resolve([]);
            return d;
        }

        // do any folders have folders?
        var childServices = s.folders.map(f => s.exploreFolder(f));
        Utils.when(childServices.map(s => {
            let d = $.Deferred<Array<ServiceDirectoryModel>>();
            s.fetch({
                success: () => {
                    this.fetchFolders(s).done(folders => {
                        d.resolve(folders);
                    });
                },
                proxy: true
            });
            return d;
        })).done(folders => {
            folders.forEach(folder => childServices = childServices.concat(folder));
            d.resolve(childServices);
        });

        return d;
    }

    LoadDirectory(url: string) {
        var s = new ServiceDirectoryModel();
        s.url = url + jsonFormat;
        var d = $.Deferred<ServiceDirectoryModel>();
        s.fetch({
            success: () => d.resolve(s),
            proxy: true
        });
        return d;
    }

}
